import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const data = [{
  year: '2020',
  price: 10.66
}, {
  year: '2021',
  price: 10.98
}, {
  year: '2022',
  price: 12.01
}, {
  year: '2023',
  price: 12.91
}, {
  year: '2024',
  price: 13.45
}, {
  year: '2025',
  price: 14.12
}, {
  year: '2026',
  price: 14.78
} // Projected
];
export function PriceChart() {
  return <div className="my-10 border border-gray-200 bg-white p-6 shadow-sm font-sans" data-id="element-15">
      <div className="mb-6" data-id="element-16">
        <div className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-17">
          Data: U.S. Energy Information Administration (EIA)
        </div>
        <h3 className="font-display text-xl sm:text-2xl font-bold text-navy mb-2" data-id="element-18">
          U.S. Average Residential Electricity Price (¢/kWh), 2020-2026
        </h3>
        <p className="text-gray-600 text-sm sm:text-base" data-id="element-19">
          Prices have risen <span className="text-orange font-bold" data-id="element-20">+36%</span>{' '}
          since 2020, with an additional 8.5% increase projected for summer
          2026.
        </p>
      </div>
      <div className="h-64 w-full sm:h-80" data-id="element-21">
        <ResponsiveContainer width="100%" height="100%" data-id="element-22">
          <AreaChart data={data} margin={{
          top: 10,
          right: 10,
          left: -20,
          bottom: 0
        }} data-id="element-23">
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-24" />
            <XAxis dataKey="year" axisLine={false} tickLine={false} tick={{
            fill: '#6b7280',
            fontSize: 12
          }} dy={10} data-id="element-25" />
            <YAxis axisLine={false} tickLine={false} tick={{
            fill: '#6b7280',
            fontSize: 12
          }} domain={['dataMin - 1', 'dataMax + 1']} data-id="element-26" />
            <Tooltip contentStyle={{
            borderRadius: '0px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.05)'
          }} formatter={(value: number) => [`${value}¢ / kWh`, 'Price']} data-id="element-27" />
            <Area type="monotone" dataKey="price" stroke="#16263f" strokeWidth={3} fill="#f3f4f6" fillOpacity={1} dot={{
            r: 4,
            fill: '#e07b39',
            strokeWidth: 2,
            stroke: '#fff'
          }} activeDot={{
            r: 6,
            fill: '#e07b39',
            strokeWidth: 0
          }} data-id="element-28" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>;
}